<template>
  <main id="home">
    <hero/>
    <speakers />
    <location />
    <presenters />
    <sponsors />
  </main>
</template>

<style lang="scss" scoped>
  @import '../styles/pages/home.scss';
</style>

<script>
// @ is an alias to /src
import hero from '@/components/hero.vue';
import location from '@/components/location.vue';
import sponsors from '@/components/sponsors.vue';
import presenters from '@/components/presenters.vue';
import speakers from '@/components/speakers.vue';

export default {
  name: 'Home',
  data() {
    return {
    };
  },
  components: {
    hero,
    location,
    sponsors,
    presenters,
    speakers
  },
  methods: {
  },
  mounted() {
  },
};
</script>
